import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './Configs/Redux/Store';
import './Configs/i18n';
import AppContainer from './Modules/App/Containers/AppContainer';
import { ThemeProvider } from 'styled-components';
import { defaultTheme } from './__core/Themes/Default';
import { GlobalStyle } from './__core/Themes/GlobalStyle';
import smoothscroll from 'smoothscroll-polyfill';
import * as Sentry from '@sentry/react';
import ErrorInfo from './__core/Components/ErrorInfo/ErrorInfo';
import moment from 'moment';
import jwt_decode from 'jwt-decode';
import { get } from 'lodash';
import Cookies from 'js-cookie';
import {
  AddCustomScript,
  gtmInitialize,
  IsGTMEnable,
} from './__core/Utils/ExternalScripts';

smoothscroll.polyfill();

const token = Cookies.get('jwt');

if (token) {
  const dateNow = moment().unix();
  const decodedToken = jwt_decode(token);
  const expiration = get(decodedToken, 'exp');

  if (dateNow > expiration) {
    Cookies.remove('jwt');
  }
}

if (IsGTMEnable()) {
  AddCustomScript(gtmInitialize);
}

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <ThemeProvider theme={defaultTheme}>
      <Sentry.ErrorBoundary fallback={<ErrorInfo />}>
        <AppContainer />
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
serviceWorker.unregister();
